import * as A11yDialog from 'a11y-dialog';
import { lockBody, unlockBody } from '../helpers/lockBody';
import { bypassLazySizes } from '../helpers/lazysizes';
import { IVideoLoader, DefaultVideoLoader, HTMLVideoLoader, YoutubeLoader, VimeoLoader, VideoType } from '../helpers/video';

export class FiftyFifty {
    constructor(blockContainer: HTMLElement) {
        this.initializeVideoModal(blockContainer);
    }

    initializeVideoModal(blockContainer: HTMLElement) {
        const videoContainer = blockContainer.querySelector('[data-fifty-fifty-video]');
        if (!videoContainer) {
            return;
        }
        const modalElement = videoContainer.querySelector('[data-fifty-fifty-video-modal]');
        if (!modalElement) {
            return;
        }
        const videoLoader: IVideoLoader = this.getVideoLoader(modalElement as HTMLElement);
        const modal = new A11yDialog(modalElement as Element);
        let bodyStyles = '';
        modal.on('show', () => {
            bodyStyles = lockBody();
            videoLoader.playSafe();
        });
        modal.on('hide', () => {
            unlockBody(bodyStyles);
            videoLoader.pause();
        });
    }

    getVideoLoader(modalElement: HTMLElement): IVideoLoader {
        let videoLoader: IVideoLoader = DefaultVideoLoader;
        const video = modalElement.querySelector('video');
        const iframe = modalElement.querySelector('iframe');

        if (video) {
            videoLoader = new HTMLVideoLoader(video);
        } else if (iframe) {
            if (!bypassLazySizes(iframe)) {
                return;
            }
            const videoType = iframe.getAttribute('data-video-type') || '';
            if (videoType === VideoType.Youtube) {
                videoLoader = new YoutubeLoader(iframe);
            } else if (videoType === VideoType.Vimeo) {
                videoLoader = new VimeoLoader(iframe);
            }
        }

        return videoLoader;
    }
}
